var lists_default = {
  "fontElementMap": "D1hox",
  "orderedlist": "lPqCr",
  "bulletedlist": "sI0Jg",
  "listItem": "cnHqx"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
